module.exports = __webpack_public_path__ + "media/images/users/avatar-7-88ea37fd4d18f99f8f11f867051755c5.jpg";